<template>
  <samp>距结束：{{ minuteVal }}</samp>
</template>

<script>
export default {
  props: {
    endTime: {
      type: String,
      default: String
    }
  },
  data() {
    return {
      minuteVal: ''
    };
  },
  watch: {
    endTime() {
      window.clearInterval(this.timer);
      this.startTiming(1);
    }
  },
  created() {
    window.clearInterval(this.timer);
    this.startTiming(1);
  },
  methods: {
    startTiming(val) {
      const vm = this;
      const mss = (new Date(vm.endTime).getTime() - new Date().getTime());
      let day = Math.floor(mss / 1000 / 60 / 60 / 24);
      let hour = Math.floor(mss / 1000 / 60 / 60 - day * 24);
      let minute = Math.floor(mss / 1000 / 60 - day * 24 * 60 - hour * 60);
      let second = Math.round((mss % (1000 * 60)) / 1000);
      if (val == 1) {
        vm.timer = setInterval(() => {
          if (second >= 0) {
            second += 1;
          }
          if (second >= 60) {
            second = 0;
            minute -= 1;
          }
          if (minute < 0) {
            minute = 59;
            hour -= 1;
          }
          if (hour < 0) {
            hour = 23;
            day -= 1;
          }
          if (minute == 0 && hour == 0 && day == 0) {
            vm.minuteVal = '活动已结束';
            return;
          }
          vm.minuteVal = `${day}天${hour}小时${minute}分`;
        }, 1000);
      } else {
        window.clearInterval(vm.timer);
      }
    }
  }
};
</script>
